export default __webpack_public_path__ + "static/media/brainstorming.eae19261.png";